export default __webpack_public_path__ + "static/media/02_Fii.964aa37e.png";